export default __webpack_public_path__ + "static/media/Reports.abb27b74.svg";